!function () {
  function initUnitToggle(toggle) {
    var table = toggle.closest('.sizeguide-v2').querySelector('[data-sizeguide-table]');
    if (!table) return;
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-unit]');
      if (!btn) return;
      var unit = btn.getAttribute('data-unit');
      toggle.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      table.querySelectorAll('td[data-in]').forEach(function (cell) {
        cell.textContent = unit === 'cm' ? cell.getAttribute('data-cm') : cell.getAttribute('data-in');
      });
    });
  }

  document.querySelectorAll('[data-sizeguide-unit-toggle]').forEach(initUnitToggle);
}();
